<script setup>
import CardsNews from "@/components/News/CardsNews.vue";
</script>

<template>
  <div class="heading1 !mb-2">
    projects
    <hr class="gradientLine" />
  </div>
  <div class="w-full flex flex-wrap gap-4 k1:justify-start justify-center">
    Coming soon...
    <CardsNews></CardsNews>
  </div>
</template>

<style scoped></style>
